import React from "react";
import { withRouter } from "react-router-dom";
import { GetProductById, GetRegionAndcountries } from "../../../api/Product";
import "../../../scss/style.css";
import { dateFormatterDMY } from "../../../helper/func";
import { connect } from "react-redux";
import * as actions from "../../../actions";
import {
  PageContainer,
  ProductDetailCard,
  BackButton,
  BackArrow,
  ProductRow,
  LeftColumn,
  RightColumn,
  ProductName,
  Specification,
  PriceSection,
  PriceLabel,
  Price,
  BuyButton,
  DetailLabel,
  DetailValue,
  DetailValueLarge,
  RegionSection,
  RegionCol,
  CountryCount,
  LoadingContainer,
  ErrorContainer,
} from "./ProductDetail.elements";
import PurchaseConfirmModal from "../../../components/PurchaseConfirmModal/PurchaseConfirmModal";
import { IsRechargeProduct } from "../../../api/Recharge";


class ProductDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      product: null,
      regionData: null,
      isLoading: true,
      error: null,
      showConfirmModal: false,
      showAllCountries: false,
    };
    this.handleBackClick = this.handleBackClick.bind(this);
  }

  componentDidMount() {
    this.fetchProductDetail();
  }

  componentDidUpdate(prevProps, prevState) {
    const prevProductId = prevProps.match.params.id;
    const currentProductId = this.props.match.params.id;

    if (prevProductId !== currentProductId) {
      this.fetchProductDetail();
    }
  }

  async fetchProductDetail() {
    const { id } = this.props.match.params;
    try {
      const productData = await GetProductById(id);
      const regionAndcoungtry = await GetRegionAndcountries(id);

      if (productData) {
        const processedRegionData = this.processRegionCountryData(
          regionAndcoungtry.records
        );

        this.setState({
          product: productData.data,
          regionData: processedRegionData,
          isLoading: false,
        });
      } else {
        this.setState({
          error: "Product not found.",
          isLoading: false,
        });
      }
    } catch (err) {
      console.error("Error fetching product detail:", err);
      this.setState({
        error: "Failed to load product details.",
        isLoading: false,
      });
    }
  }

  processRegionCountryData(regionCountryData) {
    if (!regionCountryData || regionCountryData === 0) {
      return null;
    }
    const firstItem = regionCountryData[0];

    let countries = [];
    if (firstItem.description && firstItem.description.trim() !== "") {
      countries = firstItem.description
        .split(/[,;\n]/)
        .map((c) => c.trim())
        .filter(Boolean);
    } else {
      countries = regionCountryData
        .map((item) => item.countryName)
        .filter((c, i, self) => c && self.indexOf(c) === i);
    }
    return {
      regionName: firstItem.regionName,
      countries,
      countriesString: countries.join(", "),
    };
  }

  handleBackClick() {
    this.props.history.push({ pathname: "/home" });
  }

  handleBuyClick = async () => {
    const { product } = this.state;
    let isRecharge = false;
    try {
      const result = await IsRechargeProduct(product.productId || product.id);
      isRecharge = !!(result && result.status && result.data && result.data.isRecharge);
    } catch (error) {
      console.error("Error checking product type:", error);
    }

    if (isRecharge) {
      this.props.history.push({
        pathname: "/home/confirmPage",
        state: { product },
      });
    } else {
      this.setState({ showConfirmModal: true });
    }
  };

  handleCloseConfirmModal = () => {
    this.setState({ showConfirmModal: false });
  };

  render() {
    const { product, isLoading, error, regionData } = this.state;

    if (isLoading) {
      return (
        <LoadingContainer>
          <p>Loading...</p>
        </LoadingContainer>
      );
    }

    if (error || !product) {
      return (
        <ErrorContainer>
          <p>{error || "No product data available."}</p>
        </ErrorContainer>
      );
    }

    const productName = product.productName || "Product Name";
    const specification = product.specification || "";
    const price = product.sellPrice ? Math.round(product.sellPrice) : ""; //Change product.sellPrice.toFixed(2)
    const expireDate = dateFormatterDMY(product.expire);
    const COUNTRY_LIMIT = 15;
    const { showAllCountries } = this.state;
    const allCountries = regionData.countries || [];
    const isTruncated = allCountries.length > COUNTRY_LIMIT;
    const visibleCountries = showAllCountries
      ? allCountries
      : allCountries.slice(0, COUNTRY_LIMIT);
    const visibleCountriesString = visibleCountries.join(", ");

    return (
      <PageContainer>
        <ProductDetailCard>
          <BackButton onClick={this.handleBackClick}>
            <BackArrow>&larr;</BackArrow>
            <span>Back to Products</span>
          </BackButton>

          <ProductRow>
            <LeftColumn md={6} xs={12}>
              <ProductName>{productName}</ProductName>

              {specification && <Specification>{specification}</Specification>}

              <PriceSection>
                <PriceLabel>Price</PriceLabel>
                <Price>{price} MMK</Price>
              </PriceSection>

              <BuyButton onClick={this.handleBuyClick}>Buy Now</BuyButton>
            </LeftColumn>

            <RightColumn md={6} xs={12}>
              {/* <SectionTitle>Details</SectionTitle>

                        <ExpireInfoCard>
                            <DetailLabel>Validity / Info</DetailLabel>
                            <DetailValue>{expireDate}</DetailValue>
                        </ExpireInfoCard> */}

              {/* <Divider /> */}

              <RegionSection>
                <RegionCol xs={12}>
                  <DetailLabel>Region</DetailLabel>
                  <DetailValueLarge>{regionData.regionName}</DetailValueLarge>
                </RegionCol>

                <RegionCol xs={12}>
                  <DetailLabel>Available Countries</DetailLabel>
                  <DetailValue>
                    {visibleCountriesString}
                    {isTruncated && !showAllCountries && "…"}
                  </DetailValue>
                  <CountryCount>
                    ({allCountries.length} countries)
                  </CountryCount>
                  {isTruncated && (
                    <span
                      style={{ color: "#007bff", cursor: "pointer", fontWeight: 600 }}
                      onClick={() =>
                        this.setState({ showAllCountries: !showAllCountries })
                      }
                    >
                      {showAllCountries ? "Show less" : "View all countries"}
                    </span>
                  )}
                </RegionCol>
              </RegionSection>
            </RightColumn>
          </ProductRow>
        </ProductDetailCard>

        <PurchaseConfirmModal
          isOpen={this.state.showConfirmModal}
          product={this.state.product}
          renewalContext={null}
          onCancel={this.handleCloseConfirmModal}
          history={this.props.history}
        />
      </PageContainer>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, actions)(withRouter(ProductDetail));